import React from "react";

import { StyledSVG } from "../StyledIcon";

export const EditIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M12.9062 1.45711C13.2967 1.06658 13.9299 1.06658 14.3204 1.45711L16.5424 3.67917C16.933 4.06969 16.933 4.70285 16.5424 5.09338L6.94678 14.689L3.31051 11.0528L12.9062 1.45711Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.3125 11.0522L2.5683 15.4327L6.94877 14.6885"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
